module.exports = __webpack_public_path__ + "img/apres2.9796b46c.png";